import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ReportManagementService } from '../report-management.service';

@Component({
  selector: 'app-modal-calculate',
  templateUrl: './modal-calculate.component.html',
  styleUrls: ['./modal-calculate.component.scss']
})
export class ModalCalculateComponent implements OnInit {
  isLoading: boolean;
  modalData: any;
  calculateForm: FormGroup;
  allChoice;
  isHaveChoice: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCalculateComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private reportManagementService: ReportManagementService
  ) {
    this.modalData = data;
    // console.log(this.modalData);
  }

  ngOnInit(): void {
    this.calculateForm = this.fb.group({
      TYPE: ['', Validators.required],
      FORMULA: ['', Validators.required],
      OUTPUT: ['', Validators.required],
      DETAIL: this.fb.array([]),
      M: [''],
      SD: [''],
      X: ['']
    })

    if (this.modalData.isEdit) {
      this.calculateForm = this.fb.group({
        TYPE: [this.modalData.calData.TYPE, Validators.required],
        FORMULA: [this.modalData.calData.FORMULA, Validators.required],
        OUTPUT: [this.modalData.calData.OUTPUT, Validators.required],
        DETAIL: this.fb.array([]),
        M: [this.modalData.calData.M],
        SD: [this.modalData.calData.SD],
        X: [this.modalData.calData.X]
      })

      this.detailArray.removeAt(this.modalData.calData.DETAIL.length - 1);
      this.modalData.calData.DETAIL.map((res, i) => {
        this.detailArray['controls'].push(this.fb.group({
          min_range: [res.min_range, Validators.required],
          max_range: [res.max_range, Validators.required],
          description: [res.description, Validators.required]
        }))
      })

      switch (this.modalData.calData.TYPE) {
        case 'multiple_choice': {
          this.changeType(false);
          this.calculateForm.get('NUM_ANSWER').setValue(this.modalData.calData.NUM_ANSWER);
          break;
        }

        case 'rating': {
          this.changeType(false);
          this.calculateForm.get('MIN_RANGE').patchValue(this.modalData.calData.MIN_RANGE);
          this.calculateForm.get('MAX_RANGE').patchValue(this.modalData.calData.MAX_RANGE);

          this.modalData.calData.NUM_ANSWER_ARR.forEach(res => {
            this.numAnswerArray['controls'].push(this.fb.group({
              ID: [res.ID, Validators.required],
              INVERT: [res.INVERT],
              NUMBER: [res.NUMBER, Validators.required],
              CHOICES_LENGTH: [res.CHOICES_LENGTH]

            }));
          })
          this.numAnswerArray.updateValueAndValidity();

          break;
        }

        case 'most/least': {
          this.changeType(false);
          this.modalData.calData.NUM_ANSWER.map(res => {
            this.numAnswerArray['controls'].push(this.fb.group({
              ID: res.ID,
              NUMBER: res.NUMBER,
              ANSWER: [[res.most, res.least]],
              most: res.most,
              least: res.least,
              data_answer: [res.data_answer]
            }));
          })
          break;
        }

        case 'ranking': {
          this.changeType(false);

          this.modalData.calData.DATA.map((res, i) => {
            this.dataArray.push(this.fb.group({
              ID: [res.ID, Validators.required],
              NUMBER: [res.NUMBER, Validators.required],
              MIN_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
              MAX_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
              NUM_ANSWER: new FormArray([]),
              ALL_CHOICE: new FormArray([])
            }))
            this.dataArray['controls'][i].get('NUM_ANSWER')['controls'].push(this.fb.group({
              choice_id: [res.NUM_ANSWER[0].choice_id, Validators.required],
              choice_detail: [res.NUM_ANSWER[0].choice_detail, Validators.required],
              invert: [res.NUM_ANSWER[0].invert, Validators.required]
            }))
            res.ALL_CHOICE.map(ac => {
              this.dataArray['controls'][i].get('ALL_CHOICE')['controls'].push(this.fb.group({
                choice_id: [ac.choice_id, Validators.required],
                choice_detail: [ac.choice_detail, Validators.required]
              }))
            })
            this.dataArray.updateValueAndValidity();
          })
          break;
        }
      }
      // // console.log(this.calculateForm.value);
    }

    // console.log(this.detailArray);
  }

  addCalculate(form) {
    switch (form.value.TYPE) {
      case ('multiple_choice'): {
        let ans = [];
        form.value.NUM_ANSWER.map(res => {
          ans.push({
            ANSWER: res.choice_id,
            ID: res.ID,
            LABEL: res.LABEL,
            NUMBER: res.NUMBER,
            choice_detail: res.choice_detail,
            choice_id: res.choice_id,
            media: {
              file_name: res.media.file_name,
              media_type: res.media.media_type
            }
          })
        })

        const uniqueValues = new Set(ans.map(v => v.ID));
        if (uniqueValues.size !== ans.length) {
          alert('ข้อ : เฉลย ไม่ถูกต้องเนื่องจากมีการเลือกข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else {
          form.get('NUM_ANSWER').setValue(ans.reverse());
          const response = {
            status: true,
            data: form.value
          }
          this.dialogRef.close(response);
        }
        break;
      }

      case ('rating'): {
        const uniqueValues = new Set(form.value.NUM_ANSWER_ARR.map(v => v.ID));
        const length = new Set(form.value.NUM_ANSWER_ARR.map(v => v.CHOICES_LENGTH));
        // console.log(form.value.NUM_ANSWER_ARR);

        if (uniqueValues.size !== form.value.NUM_ANSWER_ARR.length) {
          alert('การเลือกข้อไม่ถูกต้อง เนื่องจากมีข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else if ((length.values().next().value !== ((form.value.MAX_RANGE - form.value.MIN_RANGE) + 1)) || (length.size !== 1)) {
          alert(length.size !== 1 ? 'จำนวนระดับในแต่ละข้อไม่ตรงกัน กรุณาลองใหม่อีกครั้ง' : `ค่า Range ต้องมีความยาว ${length.values().next().value} กรุณาลองใหม่อีกครั้ง`);
        } else {
          // change NUM_ANSWER_ARR to NUM_ANSWER
          let newForm = JSON.parse(JSON.stringify(form.value));
          newForm['NUM_ANSWER'] = form.value.NUM_ANSWER_ARR;

          const response = {
            status: true,
            data: newForm
          }
          this.dialogRef.close(response);

        }
        break;
      }

      case ('ranking'): {
        const response = {
          status: true,
          data: form.value
        }
        this.dialogRef.close(response);
        break;
      }

      case ('most/least'): {
        const uniqueValues = new Set(form.value.NUM_ANSWER_ARR.map(v => v.ID));
        if (uniqueValues.size !== form.value.NUM_ANSWER_ARR.length) {
          alert('การเลือกข้อไม่ถูกต้อง เนื่องจากมีข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else {
          let newForm = JSON.parse(JSON.stringify(form.value));

          newForm['NUM_ANSWER'] = form.value.NUM_ANSWER_ARR;
          newForm['NUM_ANSWER'].map(res => {
            res.ANSWER[0] = res.most;
            res.ANSWER[1] = res.least
          })
          newForm['NUM_ANSWER_ARR'].map(res => {
            res.ANSWER[0] = res.most;
            res.ANSWER[1] = res.least
          })

          const response = {
            status: true,
            data: newForm
          }
          this.dialogRef.close(response);
        }
        break;
      }
    }
  }

  editCalculate(form) {
    // console.log('edit value ->>', form.value);

    switch (form.value.TYPE) {
      case 'multiple_choice': {
        let ans = [];
        form.value.NUM_ANSWER.map(res => {
          ans.push({
            ANSWER: res.choice_id,
            ID: res.ID,
            LABEL: res.LABEL,
            NUMBER: res.NUMBER,
            choice_detail: res.choice_detail,
            choice_id: res.choice_id,
            media: {
              file_name: res.media.file_name,
              media_type: res.media.media_type
            }
          })
        })

        const uniqueValues = new Set(ans.map(v => v.ID));
        if (uniqueValues.size !== ans.length) {
          alert('ข้อ : เฉลย ไม่ถูกต้องเนื่องจากมีการเลือกข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else {
          form.get('NUM_ANSWER').setValue(ans.reverse());
          const response = {
            status: true,
            data: form.value
          }
          this.dialogRef.close(response);
        }
        break;
      }

      case 'rating': {
        const uniqueValues = new Set(form.value.NUM_ANSWER_ARR.map(v => v.ID));
        const length = new Set(form.value.NUM_ANSWER_ARR.map(v => v.CHOICES_LENGTH));

        if (uniqueValues.size !== form.value.NUM_ANSWER_ARR.length) {
          alert('การเลือกข้อไม่ถูกต้อง เนื่องจากมีข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else if ((length.values().next().value !== ((form.value.MAX_RANGE - form.value.MIN_RANGE) + 1)) || (length.size !== 1)) {
          alert(length.size !== 1 ? 'จำนวนระดับในแต่ละข้อไม่ตรงกัน กรุณาลองใหม่อีกครั้ง' : `ค่า Range ต้องมีความยาว ${length.values().next().value} กรุณาลองใหม่อีกครั้ง`);
        } else {
          // change NUM_ANSWER_ARR to NUM_ANSWER
          let newForm = JSON.parse(JSON.stringify(form.value));
          newForm['NUM_ANSWER'] = form.value.NUM_ANSWER_ARR;

          const response = {
            status: true,
            data: newForm
          }
          this.dialogRef.close(response);
        }
        break;
      }

      case 'ranking': {
        const response = {
          status: true,
          data: form.value
        }
        this.dialogRef.close(response);
        break;
      }

      case 'most/least': {
        const uniqueValues = new Set(form.value.NUM_ANSWER_ARR.map(v => v.ID));
        if (uniqueValues.size !== form.value.NUM_ANSWER_ARR.length) {
          alert('การเลือกข้อไม่ถูกต้อง เนื่องจากมีข้อซ้ำ กรุณาลองใหม่อีกครั้ง');
        } else {
          let newForm = JSON.parse(JSON.stringify(form.value));

          newForm['NUM_ANSWER'] = form.value.NUM_ANSWER_ARR;
          newForm['NUM_ANSWER'].map(res => {
            res.ANSWER[0] = res.most;
            res.ANSWER[1] = res.least
          })
          newForm['NUM_ANSWER_ARR'].map(res => {
            res.ANSWER[0] = res.most;
            res.ANSWER[1] = res.least
          })

          const response = {
            status: true,
            data: newForm
          }
          this.dialogRef.close(response);
        }
        break;
      }
    }
  }

  changeType(isClear) {
    // // console.log(this.calculateForm.value);
    if (isClear) {
      this.detailArray.clear();
    }
    this.calculateForm.removeControl('NUM_ANSWER');
    this.calculateForm.removeControl('NUM_ANSWER_ARR');
    this.calculateForm.removeControl('MIN_RANGE');
    this.calculateForm.removeControl('MAX_RANGE');
    this.calculateForm.removeControl('DATA');

    let body = {
      MEASURE_ID: this.modalData.measureId,
      CATEGORY: this.calculateForm.value.TYPE
    }

    switch (this.calculateForm.value.TYPE) {
      case 'multiple_choice': {
        this.calculateForm.addControl('NUM_ANSWER', new FormControl([], Validators.required));
        this.reportManagementService.getDataByMultiChoice(body).pipe(
          map(res => {
            // // console.log(res);
            this.allChoice = res.result;
            this.isHaveChoice = this.allChoice.length > 0 ? true : false;
          })
        ).subscribe();
        break;
      }

      case 'rating': {
        if (!this.modalData.isEdit) {
          this.calculateForm.addControl('NUM_ANSWER_ARR', new FormArray([this.fb.group({
            ID: ['', Validators.required],
            INVERT: [false],
            NUMBER: ['', Validators.required],
            CHOICES_LENGTH: ['']
          })], Validators.required));
        } else {
          this.calculateForm.addControl('NUM_ANSWER_ARR', new FormArray([], Validators.required));
        }
        this.calculateForm.addControl('MIN_RANGE', new FormControl('', Validators.required));
        this.calculateForm.addControl('MAX_RANGE', new FormControl('', Validators.required));

        this.reportManagementService.getDataByRating(body).pipe(
          map(res => {
            // console.log(res);
            this.allChoice = res.result;
            this.isHaveChoice = this.allChoice.length > 0 ? true : false;
          })
        ).subscribe();
        break;
      }

      case 'ranking': {
        if (!this.modalData.isEdit) {
          this.calculateForm.addControl('DATA', new FormArray([this.fb.group({
            ID: ['', Validators.required],
            NUMBER: ['', Validators.required],
            MIN_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
            MAX_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
            NUM_ANSWER: new FormArray([
              this.fb.group({
                choice_id: '',
                choice_detail: '',
                invert: false
              })
            ]),
            ALL_CHOICE: new FormArray([])
          })], Validators.required));
        } else {
          this.calculateForm.addControl('DATA', new FormArray([], Validators.required));
        }
        this.reportManagementService.getDataByRanking(body).pipe(
          map(res => {
            // // console.log(res);
            this.allChoice = res.result;
            this.isHaveChoice = this.allChoice.length > 0 ? true : false;
          })
        ).subscribe();
        break;
      }

      case 'most/least': {
        if (!this.modalData.isEdit) {
          this.calculateForm.addControl('NUM_ANSWER_ARR', new FormArray([this.fb.group({
            ID: ['', Validators.required],
            ANSWER: ['', ''],
            NUMBER: ['', Validators.required],
            most: ['', Validators.required],
            least: ['', Validators.required],
            data_answer: [[]]
          })], Validators.required));
        } else {
          this.calculateForm.addControl('NUM_ANSWER_ARR', new FormArray([], Validators.required));
        }
        this.reportManagementService.getDataByMostLeast(body).pipe(
          map(res => {
            // // console.log(res);
            this.allChoice = res.result;
            this.isHaveChoice = this.allChoice.length > 0 ? true : false;
          })
        ).subscribe();
        break;
      }
    }

    // // console.log(this.calculateForm.value);
    if (isClear) {
      this.addScore();
    }
  }

  // for most/least
  changeSelectMostLeast(form, e) {
    form.controls['most'].reset();
    form.controls['least'].reset();

    let v = this.allChoice.filter(c => c.ID == e.target.value);

    form.patchValue({
      ID: v[0].ID,
      NUMBER: v[0].NUMBER,
      ANSWER: ['', ''],
      data_answer: v[0].data_answer
    })
    form.updateValueAndValidity();
    // // console.log(form.value);
  }

  selectAnswerMostLeast(form, j) {
    if (form.value.most === form.value.least) {
      if (j === 0) {
        form.get('most').reset();
        alert('ค่า Most ไม่ถูกต้องเนื่องจากมีค่าเท่ากับ Least กรุณาลองใหม่อีกครั้ง');
      } else {
        form.get('least').reset();
        alert('ค่า Least ไม่ถูกต้องเนื่องจากมีค่าเท่ากับ Most กรุณาลองใหม่อีกครั้ง');
      }
      form.updateValueAndValidity();
    }
  }

  // for edit most/least
  changeSelectMostLeastEdit(form, e, i) {
    form.controls['most'].reset();
    form.controls['least'].reset();

    let v = this.allChoice.filter(c => c.ID == e.target.value);

    this.calculateForm.value.NUM_ANSWER_ARR[i].ID = +v[0].ID;
    this.calculateForm.value.NUM_ANSWER_ARR[i].NUMBER = +v[0].NUMBER;

    form.patchValue({
      ID: v[0].ID,
      NUMBER: v[0].NUMBER,
      ANSWER: ['', ''],
      data_answer: v[0].data_answer
    })
    form.updateValueAndValidity();
    // // console.log(form.value);
  }

  // for edit most/least
  selectAnswerMostLeastEdit(form, isMost, i) {
    // // console.log(this.calculateForm.value.NUM_ANSWER_ARR[i].ID);

    if (form.value.most === form.value.least) {
      if (isMost === 0) {
        form.get('most').reset();
        alert('ค่า Most ไม่ถูกต้องเนื่องจากมีค่าเท่ากับ Least กรุณาลองใหม่อีกครั้ง');
      } else {
        form.get('least').reset();
        alert('ค่า Least ไม่ถูกต้องเนื่องจากมีค่าเท่ากับ Most กรุณาลองใหม่อีกครั้ง');
      }
      form.updateValueAndValidity();
    } else {
      if (isMost === 0) {
        this.calculateForm.value.NUM_ANSWER_ARR[i].most = form.value.most;
      } else {
        this.calculateForm.value.NUM_ANSWER_ARR[i].least = form.value.least;
      }
    }
  }

  // for rating
  changeSelectValue(form, e) {
    // // console.log(form.value);

    let v = this.allChoice.filter(c => c.ID == e.target.value);
    // console.log(v);

    form.patchValue({
      ID: +v[0].ID,
      INVERT: form.value.INVERT,
      NUMBER: +v[0].NUMBER,
      CHOICES_LENGTH: +v[0].CHOICES_LENGTH
    })
    form.updateValueAndValidity();
    // console.log(this.calculateForm.value);
  }

  // for edit rating
  changeSelectValueEdit(form, e, i) {
    // // console.log(form.value);

    let v = this.allChoice.filter(c => c.ID == e.target.value);
    // // console.log(v);

    // ใช้อัปเดตค่าเก่าในกรณีเปลี่ยนข้อ
    this.calculateForm.value.NUM_ANSWER_ARR[i].ID = +v[0].ID;
    this.calculateForm.value.NUM_ANSWER_ARR[i].INVERT = form.value.INVERT;
    this.calculateForm.value.NUM_ANSWER_ARR[i].NUMBER = +v[0].NUMBER;
    this.calculateForm.value.NUM_ANSWER_ARR[i].CHOICES_LENGTH = +v[0].CHOICES_LENGTH;

    // มีไว้เพื่อกรณีเพิ่มข้อใหม่ต้อง patch value ไม่งั้นกดบันทึกไม่ได้
    form.patchValue({
      ID: +v[0].ID,
      INVERT: form.value.INVERT,
      NUMBER: +v[0].NUMBER,
      CHOICES_LENGTH: +v[0].CHOICES_LENGTH
    })
    form.updateValueAndValidity();
    // // console.log(this.calculateForm.value);
  }

  // for edit rating
  changeInvertEdit(type, e, i) {
    if (type === 'rating') {
      this.calculateForm.value.NUM_ANSWER_ARR[i].INVERT = e.checked;
    }
  }

  // for ranking
  changeSelectRanking(form, e) {
    while (form.get('ALL_CHOICE').length !== 0) {
      form.get('ALL_CHOICE').removeAt(0)
    }

    let v = this.allChoice.filter(c => c.ID == e.target.value);

    v[0].data_answer.map(v => {
      form.get('ALL_CHOICE').push(this.fb.group({
        choice_id: v.choice_id,
        choice_detail: v.choice_detail
      }))
    })

    form.patchValue({
      ID: v[0].ID,
      NUMBER: v[0].NUMBER,
      MIN_RANGE: 0, // ไม่ใช้ในการคำนวณแล้ว
      MAX_RANGE: 0, // ไม่ใช้ในการคำนวณแล้ว
    })

    form.updateValueAndValidity();
  }

  selectRanking(form, e) {
    let v = form.get('ALL_CHOICE')['controls'].filter(c => c.value.choice_id == e.target.value);

    form.get('NUM_ANSWER').at(0).patchValue({
      choice_id: v[0].value.choice_id,
      choice_detail: v[0].value.choice_detail
    });
    form.controls.NUM_ANSWER.value[0].choice_id = v[0].value.choice_id;
    form.controls.NUM_ANSWER.value[0].choice_detail = v[0].value.choice_detail;
    form.updateValueAndValidity();
  }

  changeInvertRanking(form, e) {
    form.get('NUM_ANSWER').at(0).patchValue({
      invert: e.checked
    });
    form.controls.NUM_ANSWER.value[0].invert = e.checked;
    form.updateValueAndValidity();
  }

  // for edit min_range or max_range
  changeRange(type, e, i) {
    if (type === 'min') {
      this.calculateForm.value.DETAIL[i].min_range = +e.target.value;
    } else {
      this.calculateForm.value.DETAIL[i].max_range = +e.target.value;
    }
  }

  // for edit detail
  changeDetail(e, i) {
    this.calculateForm.value.DETAIL[i].description = e.target.value;
  }

  addScore() {
    this.detailArray.push(this.fb.group({
      min_range: ['', Validators.required],
      max_range: ['', Validators.required],
      description: ['', Validators.required]
    }))
  }

  addRating() {
    this.numAnswerArray.push(this.fb.group({
      ID: ['', Validators.required],
      INVERT: [false],
      NUMBER: ['', Validators.required],
      CHOICES_LENGTH: ['']
    }))
  }

  addMostLeast() {
    this.numAnswerArray.push(this.fb.group({
      ID: ['', Validators.required],
      ANSWER: ['', ''],
      NUMBER: ['', Validators.required],
      most: ['', Validators.required],
      least: ['', Validators.required],
      data_answer: [[]]
    }))
  }

  addRanking() {
    this.dataArray.push(this.fb.group({
      ID: ['', Validators.required],
      NUMBER: ['', Validators.required],
      MIN_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
      MAX_RANGE: [0, Validators.required], // ไม่ใช้ในการคำนวณแล้ว
      NUM_ANSWER: new FormArray([
        this.fb.group({
          choice_id: '',
          choice_detail: '',
          invert: false
        })
      ]),
      ALL_CHOICE: new FormArray([])
    }))
  }

  // use with rating, most/least
  removeAnswer(i) {
    this.numAnswerArray.removeAt(i);
  }

  removeRankingData(i) {
    this.dataArray.removeAt(i);
  }

  changeFormula() {
    this.calculateForm.get('OUTPUT').reset();
    this.calculateForm.get('M').reset();
    this.calculateForm.get('X').reset();
    this.calculateForm.get('SD').reset();
  }

  removeDetail(i) {
    this.detailArray.removeAt(i);
  }

  // for multiple choice
  sortByArray(e) {
    e.sort((v1, v2) => v1.LABEL > v2.LABEL ? 1 : -1);
    // // console.log(this.calculateForm.value.NUM_ANSWER);
  }

  get detailArray(): FormArray {
    return this.calculateForm.get('DETAIL') as FormArray;
  }

  get numAnswerArray(): FormArray {
    return this.calculateForm.get('NUM_ANSWER_ARR') as FormArray;
  }

  get dataArray(): FormArray {
    return this.calculateForm.get('DATA') as FormArray;
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

  compareMultipleChoice(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.LABEL === i2.LABEL : i1 === i2;
  }
}
